document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.animate_fade');

  const options = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    threshold: 0.1 // Trigger when at least 10% of the section is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target); // Stop observing once the section is visible
      }
    });
  }, options);

  sections.forEach(section => {
    observer.observe(section);
  });
});